import api from '.';

import { buildQueryWithParams, makeListTags } from '../../Utils/api';

const tagType = 'provider';

const providersApi = api.injectEndpoints({
  endpoints: (builder) => ({

    requestAllProviders: builder.query({
      query: (filter) => ({
        url: '/organization-type',
        method: 'GET',
        params: { filter },
      }),
      transformResponse(res) {
        return {list:res[0]?.organizations}
      }
    }),
    updateProvider: builder.mutation({
      query: ({data,id}) => ({
        url: `/organizations/${id}`,
        method: 'PATCH',
        body: data
      }),
    }),
    createProvider: builder.mutation({
      query: (props) => ({
        url: '/organizations',
        method: 'POST',
        body: props
      }),
      invalidatesTags: [tagType]
    }),
    updateProviderProperties: builder.mutation({
      query: ({data,id}) => ({
        url: `/organization-properties/${id}`,
        method: 'PATCH',
        body: data
      }),
      invalidatesTags: [tagType]
    }),
    deleteProviderProperties: builder.mutation({
      query: (id) => ({
        url: `/organization-properties/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: [tagType]
    }),
    createProviderProperties: builder.mutation({
      query: ({data,orgId}) => ({
        url: `/organizations/${orgId}/organization-properties`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: [tagType]
    }),
    deleteProvider: builder.mutation({
      query: (id) => ({
        url: buildQueryWithParams(`/organizations/${id}`),
        method: 'DELETE'
      }),
      invalidatesTags: [tagType]
    })
  })
});

export default providersApi;

export const {
  useDeleteProviderMutation,
  useRequestAllProvidersQuery,
  useRequestProvidersDetailsQuery,
  useCreateProviderPropertiesMutation,
  useUpdateProviderMutation,
  useCreateProviderMutation,
  useUpdateProviderPropertiesMutation,
  useDeleteProviderPropertiesMutation
} = providersApi;
